const initialState = {
  inputValue: "",
  origRawSearchedData:[],
  rawSearchData:[],
  origSearchData: [],
  searchData: [],
  selectedQuestionUuid: null,
  selectedQuestion: {},
  selectedAnswer: {},
  autoSuggestion: [],
  isLoading: false,
  usersProfilePicData: [],
  topicUuid: "",
  isShowAskButton: false,
  generativeText:"",
  summaryUuid:'',
  refferedSuggestions:[],
  origGenerativeText:"",
  isShow:false,
  isOpenSideBar:false,
  regenerateText:'0',
  selectedSources:[],
  lang:'English',
  isSalesSummary:'Technical',
  isShortChecked:'Detailed',
  isRegenerating:false,
  expertData:[],
  docData:[],
  isExternal:false
};

const invalidResponse = (str) => {
  if(str.length > 13){
    let newStr = str.split(' ');
  if(newStr[0] === 'I' && newStr[1] === `don't`  && newStr[2] === 'know.'){
    return false;
  }else{
    return true;
  }
  }else{
    return false;
  }
}
const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case "searchinputvalue":
      // state.inputValue = action.payload;
      state = { ...state, inputValue: action.payload };
      return state;
    case "getautosuggestion":
      state = { ...state, autoSuggestion: action.payload };
      return state;
    case "updateSelectedQuestionUuid":
      state = { ...state, selectedQuestionUuid: action.payload };
      return state;
    case "updateSearchData":
      let formatData = action.payload.filter(obj=>{
        return obj.confidence === true;
      })
      state = { ...state, isLoading: false };
      state = { ...state, origSearchData: action.payload,lang:'English', isSalesSummary:'Technical', isShortChecked:'Detailed'};
      state = { ...state, searchData: formatData };
      return state;
    case "searchloadingstart":
      state = { ...state, isLoading: action.payload };
      return state;
    case "searchexpertProfilePicData":
      state = { ...state, usersProfilePicData: state.usersProfilePicData.concat(action.payload) };
      return state;
    case "updateTopicUuid":
      state = { ...state, topicUuid: action.payload };
      return state;
    case "updateSelectedQuestion":
      state = { ...state, selectedQuestion: action.payload };
      return state;
    case "updateSelectedAnswer":
      state = { ...state, selectedAnswer: action.payload };
      return state;
    case "filteredSearchData":
      state = { ...state, searchData: action.payload };
      return state;
    case "updateIsShowAskTheTeamButton":
      state = { ...state, isShowAskButton: action.payload };
      return state;
    case "updateGenerativeAIText":
      state = { ...state, summaryUuid: action.payload };
      return state;
    case "getrefferedSuggestions":
      state = { ...state, refferedSuggestions: action.payload };
      return state;
    case "captureAIGeneratedTextFromWebSocket":
      state = { ...state, summaryUuid: action.payload.summaryUuid };
      if(action.payload.generatedText && action.payload.summaryUuid === state.summaryUuid &&  invalidResponse(action.payload.generatedText)){
      state = { ...state, generativeText: action.payload.generatedText };
      state = { ...state, origGenerativeText: action.payload.generatedText };

      }
      return state;
    case "UpdateGenerativeAITextWhenAPICall":
      state = { ...state, summaryUuid: '' };
      state = { ...state, generativeText: '' };
      state = { ...state, origGenerativeText: '' };
      return state;
    case "UpdateGenerativeAITextWithDiffLang":
      state = { ...state, generativeText: action.payload };
      return state;
    case "isShowResultsCPR":
        state = { ...state, isShow: action.payload };
        return state;
    case "filteredOrigSearchData":
      state = { ...state, origSearchData: action.payload };
      return state;
    case "getRawSearchData":
      let newArr = [];
      let origIds = action.payload.filter(obj=>{
        obj.answers.filter(obj2=>{
           newArr.push(obj2.answerUuid);
        })
      })
      state = { ...state, rawSearchData: action.payload, origRawSearchedData:action.payload, selectedSources:newArr };
      return state;
    case "sidebarOpenSP":
      state = { ...state, isOpenSideBar:action.payload };
      return state;
    case "regenerateTextSP":
      state = { ...state, regenerateText:Math.random()*10 };
      return state;
    case "selectedSourcesSP":
      state = { ...state, selectedSources:action.payload };
      return state;
    case "updateLanguageSP":
      state = { ...state, lang:action.payload };
      return state;
    case "updateSalesSummaryTypeSP":
      state = { ...state, isSalesSummary:action.payload };
      return state;
    case "updateShortCheckedTypeSP":
      state = { ...state, isShortChecked:action.payload };
      return state;
    case "isRegeneratingGenAiText":
      state = { ...state, isRegenerating: action.payload };
      return state;
    case "SearchExpDocData":
      state = { ...state, expertData: action.payload.exp, docData:action.payload.doc };
      return state;
    case "changeGenerativeAITextWhenRegenerate":
      state = { ...state, origGenerativeText:action.payload };
      return state;
    case "isExternalSearchAllowed":
      state = { ...state, isExternal:action.payload };
      return state;
    default:
      return state;
  }
};

export default searchReducer;
